export default {"src":"/_next/static/media/icon-flag-china.419977cf.svg","height":27,"width":40,"blurWidth":0,"blurHeight":0};